$(document).ready(function () {
	// POPUP BANNER
	var POPUP_DELAY_MS = 1500;
	var $popup = $('.JSfirst-popup');

	if ($('body').attr('id') === 'start-page' && $popup.length && !sessionStorage.getItem('popup')) {

		setTimeout(function(){ 
			$popup.animate({ top: '50%' }, 700);
		}, POPUP_DELAY_MS);   

		$(document).on('click', function(e){
			var target = $(e.target);
			if(!target.is($('.first-popup-inner img'))) { 
				$popup.hide();
				sessionStorage.setItem('popup', '1');
				$(document).off('click');
			} 
		}); 
	}
});